export default [0, 4, 8, 12, 16, 24, 32, 40, 48, 56, 64, 80, 104];
